var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOrdersIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 16,
    viewBox: "0 0 21 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0005 5.59629V15.5C18.0005 15.7761 17.7766 16 17.5005 16H2.50049C2.22435 16 2.00049 15.7761 2.00049 15.5V5.59629L0.0362547 0.685695C-0.0951181 0.357263 0.146761 0 0.500493 0H10.5005C10.7049 0 10.8888 0.124475 10.9647 0.314305L12.5005 4.15371L14.0363 0.314305C14.1122 0.124475 14.296 0 14.5005 0H19.5005C19.8542 0 20.0961 0.357263 19.9647 0.685695L18.0005 5.59629ZM13.0005 6V15H17.0005V6H13.0005ZM3.00049 6H12.0005V15H3.00049V6ZM2.83901 5H11.762L10.162 0.999999H1.23901L2.83901 5ZM18.762 0.999999L17.162 5H13.239L14.839 0.999999H18.762ZM11.0005 11.5V13.5C11.0005 13.7761 10.7766 14 10.5005 14H7.50049C7.22435 14 7.00049 13.7761 7.00049 13.5V11.5C7.00049 11.2239 7.22435 11 7.50049 11H10.5005C10.7766 11 11.0005 11.2239 11.0005 11.5ZM8.00049 12H10.0005V13H8.00049V12Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrdersIcon);
export default __webpack_public_path__ + "static/media/OrdersIcon.c87ee9ca.svg";
export { ForwardRef as ReactComponent };